export const mapArrayToMap = (arr, key="id") => {
    const map = {}
    for(let i=0; i<arr.length; i++) 
        map[ arr[i][key] ] = arr[i]
    return map;
}